import styled, { css } from "styled-components";
import { pxToRem } from "../../styles/utils";


export const SidebarContainer = styled.aside`
  display: flex;
  flex-direction: column;
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(8)};
  margin-right: ${pxToRem(12)};
  box-shadow: ${pxToRem(2)} ${pxToRem(6)} ${pxToRem(29)} 0px rgba(0, 0, 0, 0.09);
  background: rgb(255, 255, 255);
  min-height: 100%;
`;

export const SidebarHeader = styled.h2`
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(29)};
  font-weight: 700;
  padding: ${pxToRem(16)};
  margin: 0;
`;

export const SidebarMenu = styled.nav`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: ${pxToRem(20)};
  overflow-y: auto;
  scrollbar-width: none;
  scrollbar-color: rgba(114, 82, 220, 0.5) transparent;

  &::-webkit-scrollbar {
    width: ${pxToRem(8)};
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(114, 82, 220, 0.5);
    border-radius: ${pxToRem(4)};
  }
`;

export const SidebarGroup = styled.div`
  margin-bottom: ${pxToRem(10)};
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SidebarTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${pxToRem(14)};
  font-weight: 600;
  color: rgb(185, 185, 185);
  padding-left: ${pxToRem(16)};
  margin: 0;
`;

export const SidebarItem = styled.li`
  list-style: none;
  margin: ${pxToRem(6)} 0;

  a {
    text-decoration: none;
  }
`;

export const SidebarLink = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  padding: ${pxToRem(12)};
  border-radius: ${pxToRem(12)};

  span {
    font-size: ${pxToRem(18)};
    font-weight: 500;
  }

  ${(props) =>
    props.isActive &&
    css`
      box-shadow:
        0px ${pxToRem(7)} ${pxToRem(15.4)} 0px rgba(121, 90, 223, 0.5),
        inset 0px ${pxToRem(-3)} 0px 0px rgb(105, 71, 216);

      background: linear-gradient(
          180deg,
          rgba(189, 169, 255, 0.44),
          rgba(114, 82, 220, 0.5) 100%
        ),
        rgb(114, 82, 220);

      span {
        color: rgb(255, 255, 255);
      }
      img {
        filter: invert(1);
      }
    `}

  &:hover {
    box-shadow:
      0px ${pxToRem(7)} ${pxToRem(15.4)} 0px rgba(121, 90, 223, 0.5),
      inset 0px ${pxToRem(-3)} 0px 0px rgb(105, 71, 216);

    background: linear-gradient(
        180deg,
        rgba(189, 169, 255, 0.44),
        rgba(114, 82, 220, 0.5) 100%
      ),
      rgb(114, 82, 220);

    span {
      color: rgb(255, 255, 255);
    }
    img {
      filter: invert(1);
    }
  }
`;

export const SidebarIcon = styled.img`
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  margin-right: ${pxToRem(12)};
`;

export const SidebarText = styled.span`
  font-size: ${pxToRem(18)};
  font-weight: 500;
  color: rgb(31, 10, 53);
`;

export const SidebarFooter = styled.div`
  display: flex;
  align-items: center;
  padding: ${pxToRem(12)} ${pxToRem(16)};
  border: ${pxToRem(1)} solid rgba(114, 82, 220, 0.4);
  background: rgba(114, 82, 220, 0.1);
  border-radius: ${pxToRem(10)};
  margin-top: auto;
  cursor: pointer;
`;

export const SidebarAvatar = styled.div`
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  border-radius: ${pxToRem(6)};
  font-family: ${({ theme }) => theme.fonts.secondary};
  background: rgb(114, 82, 220);
  color: rgb(255, 255, 255);
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${pxToRem(20)};
  margin-right: ${pxToRem(12)};
`;

export const SidebarUserInfo = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SidebarUserName = styled.div`
  font-size: ${pxToRem(18)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const SidebarUserEmail = styled.div`
  font-size: ${pxToRem(14)};
  font-weight: 400;
  color: rgb(114, 82, 220);
  margin-top: ${pxToRem(4)};
`;
